var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PlaybackSyncTime_playbackCurrentTime;
class PlaybackSyncTime {
    constructor(playbackCurrentTime) {
        _PlaybackSyncTime_playbackCurrentTime.set(this, void 0);
        __classPrivateFieldSet(this, _PlaybackSyncTime_playbackCurrentTime, playbackCurrentTime !== null ? playbackCurrentTime * 1000 : null, "f");
    }
    sync({ startedAt, endedAt, matched }) {
        return __classPrivateFieldGet(this, _PlaybackSyncTime_playbackCurrentTime, "f") !== null && __classPrivateFieldGet(this, _PlaybackSyncTime_playbackCurrentTime, "f") >= startedAt && __classPrivateFieldGet(this, _PlaybackSyncTime_playbackCurrentTime, "f") <= endedAt && matched !== false;
    }
}
_PlaybackSyncTime_playbackCurrentTime = new WeakMap();
export default PlaybackSyncTime;
